import { Col, Menu, Row } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IProjectDetails } from "../../types";

export default function ProjectAdminRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const { projectDetails } = useOutletContext<{ projectDetails: IProjectDetails }>();
    const [activeTab, setActiveTab] = useState("git");

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "git");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    openKeys={["integrations"]}
                >
                    <SubMenu key="integrations" title="Integrations" >
                        <Menu.Item key="git">Git</Menu.Item>
                        <Menu.Item key="cloud">Cloud Accounts</Menu.Item>
                        <Menu.Item key="container">Container Registries</Menu.Item>
                        <Menu.Item key="slack">Slack</Menu.Item>
                    </SubMenu>
                </Menu>
            </Col>
            <Col span={18}>
                <Outlet context={{ projectDetails }} />
            </Col>
        </Row >
    )
}